import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useMemo } from '@redneckz/uni-jsx/lib/hooks';
import { noop } from '../../utils/noop.js';
import { renderCalendarCells } from './renderCalendarCells.js';
const WEEK_DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const Calendar = JSX(({ today, currentMonth, currentYear, min, max, onDateSelect = noop }) => {
    const handleDateClick = useCallback((date) => onDateSelect(date), []);
    const { firstDayOfWeek, totalDays } = useMemo(() => ({
        firstDayOfWeek: new Date(currentYear, currentMonth, 1).getDay() - 1,
        totalDays: new Date(currentYear, currentMonth + 1, 0).getDate(),
    }), [currentYear, currentMonth]);
    return (_jsxs("table", { className: "mx-auto", children: [_jsx("thead", { className: "text-gray font-light", children: _jsx("tr", { children: WEEK_DAYS.map((day, index) => (_jsx("th", { className: "p-s", children: day }, String(index)))) }) }), _jsx("tbody", { children: renderCalendarCells({
                    firstDayOfWeek,
                    today,
                    totalDays,
                    currentYear,
                    currentMonth,
                    min,
                    max,
                    onDateClick: handleDateClick,
                }) })] }));
});
//# sourceMappingURL=Calendar.js.map